import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { About, Branding, Contact, Home, Portfolio,   WebDesign, WebDevelopment } from '../views'

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/webdevelopment" element={<WebDevelopment />} />
        <Route path="/services/designbranding" element={<Branding />} />
        <Route path="/services/webdesign" element={<WebDesign />} />
       
        <Route path="/portfolio" element={<Portfolio />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
